import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";

function StudentHouseDropDown() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [houses, setHouses] = useState([]);

  useEffect(() => {
    axios({
      method: "post",
      url: config.base_url + "StudentHouse/GetStudentHouses",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType },
    })
      .then((response) => {
        setHouses(response.data.ListofRecords || []);
      })
      .catch(() => setHouses([]));
  }, [AccessKey, UserID, MemberType]);

  if (houses.length === 0) {
    return null;
  }

  return houses.map((item, index) => (
    <option value={item.HouseName} key={index}>
      {item.HouseName}
    </option>
  ));
}

export default StudentHouseDropDown;
